export default __webpack_public_path__ + "fonts/MYRIADPRO-BOLD.d6bee12c7e838e84074faeb7c131c988.woff";